import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Line extends React.Component {
  render() {
    return (
      <p className="border-line" />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Line;